package app.nestbridge.feature.children.ui

import app.nestbridge.feature.children.screen.ChildrenScreen
import app.nestbridge.feature.children.screen.ChildrenState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class ChildrenUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    ChildrenScreen -> ui<ChildrenState> { state, modifier -> ChildrenUi(state = state, modifier = modifier) }
    else -> null
  }
}
